// PX-Connect-Terminerfassung als eigenständiges Modal (ADR 0005).
//
// Zweiter Einstieg neben dem Typ/Subtyp-Pfad im Korrespondenz-Modal: nur die Terminfelder,
// keine Typ/Subtyp-Auswahl — die Zuordnung ergibt sich aus dem Button. Speichern schreibt
// `pxConnectTermine` in `Projekt.metadata`; es wird KEINE Korrespondenz-Zeile angelegt.
import React from 'react';
import {
    Button,
    Center,
    HStack,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Spinner,
} from '@chakra-ui/react';
import { useModal } from '~/hooks';
import { usePxConnectTermine } from '~/pages/projects/hooks/usePxConnectTermine';
import { PxConnectTerminBlock } from './PxConnectTerminBlock';

interface PxConnectTerminModalProps {
    /** MultiModal slot id; matched against `state.modals.activeModal`. */
    id?: string;
    projectId?: number;
}

export const PxConnectTerminModal: React.FC<PxConnectTerminModalProps> = ({ projectId }) => {
    const { isOpen, onClose, dispatch } = useModal();
    const {
        values,
        ortstermine,
        setValues,
        setOrtstermine,
        save,
        saving,
        persisted,
        hasErrors,
        loading,
        ready,
        darfSchreiben,
    } = usePxConnectTermine({ projectId, active: Boolean(isOpen) });

    const onCancel = () => {
        dispatch?.({ type: 'resetState' });
        onClose?.();
    };

    const onSave = async () => {
        const saved = await save();
        if (saved) onCancel();
    };

    return (
        <ModalContent rounded="none" maxWidth="container.md">
            <ModalHeader
                p={5}
                borderBottomWidth={1}
                borderColor="gray.200"
                data-test-id="pxc-termin-modal-header"
            >
                PX Terminerfassung
            </ModalHeader>
            <ModalBody py={5}>
                {loading ? (
                    <Center py={10}>
                        <Spinner data-test-id="pxc-termin-loading" />
                    </Center>
                ) : (
                    <PxConnectTerminBlock
                        values={values}
                        ortstermine={ortstermine}
                        persisted={persisted}
                        onValuesChange={setValues}
                        onOrtstermineChange={setOrtstermine}
                        isDisabled={!darfSchreiben}
                    />
                )}
            </ModalBody>
            <ModalFooter borderTopWidth={1} borderColor="gray.200">
                <HStack>
                    <Button data-test-id="pxc-termin-cancel" variant="outline" onClick={onCancel}>
                        Abbrechen
                    </Button>
                    <Button
                        data-test-id="pxc-termin-save"
                        colorScheme="blue"
                        isLoading={saving}
                        isDisabled={!ready || loading || hasErrors || !darfSchreiben}
                        onClick={onSave}
                    >
                        Speichern
                    </Button>
                </HStack>
            </ModalFooter>
        </ModalContent>
    );
};
